import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiConfig } from '../config/api';
import { ToastContext } from '../App';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { showToast } = React.useContext(ToastContext);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch(`${apiConfig.baseURL}/auth/request-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        showToast('Se o email existir, receberá uma nova senha por email.', 'success');
      } else {
        setError(data.error || 'Erro ao processar pedido');
        showToast(data.error || 'Erro ao processar pedido', 'error');
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
      showToast('Erro de conexão. Tente novamente.', 'error');
    }

    setLoading(false);
  };

  if (success) {
    return (
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card shadow">
              <div className="card-header" style={{backgroundColor: '#a2449c'}}>
                <h4 className="mb-0 text-white text-center">
                  <i className="fas fa-check-circle me-2"></i>
                  Email Enviado
                </h4>
              </div>
              <div className="card-body text-center">
                <div className="alert alert-success">
                  <i className="fas fa-check-circle me-2"></i>
                  Se o email existir na nossa base de dados, receberá uma nova senha por email.
                </div>
                <Link to="/login" className="btn" style={{backgroundColor: '#a2449c', borderColor: '#a2449c', color: 'white'}}>
                  <i className="fas fa-arrow-left me-2"></i>
                  Voltar ao Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-header" style={{backgroundColor: '#a2449c'}}>
              <h4 className="mb-0 text-white text-center">
                <i className="fas fa-key me-2"></i>
                Recuperar Senha
              </h4>
            </div>
            <div className="card-body">
              {error && (
                <div className="alert alert-danger">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn w-100"
                  style={{backgroundColor: '#a2449c', borderColor: '#a2449c', color: 'white'}}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      A enviar...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane me-2"></i>
                      Enviar Nova Senha
                    </>
                  )}
                </button>
              </form>

              <div className="text-center mt-3">
                <p className="mb-0">
                  <Link to="/login" className="text-decoration-none" style={{color: '#a2449c'}}>
                    <i className="fas fa-arrow-left me-1"></i>Voltar ao Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage; 